import { Dropdown, Stack } from '@fluentui/react';
import React, { useState } from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';
import PrimaryButton from '../../../../Forms/PrimaryButton';
import FeatureSummary from "../../../../Util/FeatureSummary";

const DefaultPage = () => {
    let { path } = useRouteMatch();
    const history = useHistory();

    const [selectedYear, setSelectedYear] = useState();
    const [selectedMonth, setSelectedMonth] = useState();
    const onChangeYear = (event, year) => {
        setSelectedYear(year.key);
    };
    const onChangeMonth = (event, month) => {
        setSelectedMonth(month.key);
    };

    const yearOptions = [
        { key: 2023, text: '2023' },
        { key: 2024, text: '2024' },
        { key: 2025, text: '2025' },
        { key: 2026, text: '2026' },
        { key: 2027, text: '2027' },
    ];

    const monthOptions = [
        { key: 1, text: '01 - January' },
        { key: 2, text: '02 - February' },
        { key: 3, text: '03 - March' },
        { key: 4, text: '04 - April' },
        { key: 5, text: '05 - May' },
        { key: 6, text: '06 - June' },
        { key: 7, text: '07 - July' },
        { key: 8, text: '08 - August' },
        { key: 9, text: '09 - September' },
        { key: 10, text: '10 - October' },
        { key: 11, text: '11 - November' },
        { key: 12, text: '12 - December' },
    ];

    return (
        <div>
            <Stack tokens={{ childrenGap: 30 }}  style={{ maxWidth: '800px' }}>
                <Dropdown
                    label="Year"
                    selectedKey={selectedYear}
                    onChange={onChangeYear}
                    placeholder="Select a year"
                    options={yearOptions}
                />
                <Dropdown
                    label="Month"
                    selectedKey={selectedMonth}
                    onChange={onChangeMonth}
                    placeholder="Select a month"
                    options={monthOptions}
                />
                <PrimaryButton
                    text="Go"
                    onClick={() => history.push(`${path}/${selectedYear}/${selectedMonth}`)}
                    allowDisabledFocus
                    disabled={!selectedYear || !selectedMonth}
                    checked={false}
                />
            </Stack>
            <FeatureSummary
                label="More About Sweepstakes"
                summary="Select a year and month to view the sweepstakes winners for that month. Draw potential winners if not already drawn."
                imageUrlPath='sweepstakes2'
            />
        </div>
    );
};

export default DefaultPage;
